module.exports = __webpack_public_path__ + "static/media/caret-up-light.255b9b5f.svg";